module.exports = __webpack_public_path__ + "static/media/link_single.9178d36c.webp";